<template>
    <div v-loading="isSuccess">
        <div class="PaperDetails">
            <img class="imgBanner" :src="detailsData.coverurl" alt="">
            <!--选项卡-->
            <div class="tab_wrap">
                <van-tabs @change="tabChange" :class="{hiddenDetails: detailsData.qbtype === 1 && !detailsData.ishavedoc}" v-model="active">
                    <van-tab title="详情">
                        <div class="detailsBox">
                            <div class="limit-box" v-if="detailsData.islimitcount && !detailsData.isbuy">
                                <div class="left">
                                    <div>
                                        <span class="tagname">{{detailsData.tagname?detailsData.tagname:'限时秒杀价'}}</span>
                                    </div>
                                    <div class="price-box">
                                        <span class="saleprice">￥{{detailsData.saleprice}}</span>
                                        <span class="uprice" v-if="detailsData.uprice">￥{{detailsData.uprice}}</span>
                                    </div>
                                </div>
                                <div class="right">
                                    <div class="tip">距结束仅剩</div>
                                    <div class="timer-box">
                                        <span class="sepa-r" v-if="timer.day">{{timer.day}}天</span>
                                        <span class="time-box sepa-l sepa-r">{{timer.hour}}</span>:
                                        <span class="time-box sepa-l sepa-r">{{timer.minute}}</span>:
                                        <span class="time-box sepa-l">{{timer.second}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="paperInfo margin_bottom20">
                                <div class="paper_box">
                                    <div class="left">
                                        <p>{{detailsData.subject}}</p>
                                        <p v-if="detailsData.joincount">已有{{detailsData.joincount}}人参与</p>
                                    </div>
                                    <div class="right" @click="collectionClick(detailsData.isfavorite)">
                                        <img :src="detailsData.isfavorite === 1 ? require('@/common/images/mmy/enshrine.png') : require('@/common/images/mmy/no_enshrine.png')" alt="">
                                        <span :class="detailsData.isfavorite === 1 ? 'yellow_text' : ''">{{detailsData.isfavorite === 0 ? '收藏' : '取消'}}</span>
                                    </div>
                                </div>
                                <div class="coupon_box" v-if="detailsData.couponvoucherlist && detailsData.couponvoucherlist.length">
                                    <div class="coupon" @click="openGetCoupon">
                                        <div class="left">
                                            <div class="name">优惠</div>
                                            <div class="get_coupon">领券</div> 
                                            <div class="item" v-for="(item, index) in detailsData.couponvoucherlist" :key="index" v-show="index < 2">{{item.prefercontent}}</div>
                                        </div>
                                        <div class="right">
                                            <img :src="require('@/common/images/mmy/icon-arrow-right.png')" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hostInfo margin_bottom20" @click="toOrganPage">
                                <div class="hostImg">
                                    <img :src="detailsData.hostinfo.hostlogourl" alt="">
                                    <span>{{detailsData.hostinfo.hostname}}</span>
                                </div>
                                <img :src="require('@/common/images/mmy/icon-arrow-right.png')" alt="">
                            </div>
                            <!--详情-->
                            <div v-if="detailsData.content !== ''" v-html="detailsData.content" class="bank_details_div"></div>
                            <div v-if="detailsData.content === ''" class="no_data_box">
                                <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
                                <p>当前题库暂无详情</p>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab title="目录" v-if="detailsData.qbtype === 2">
                        <!--<div class="catalogBox" v-if="chapterData.length>0">-->
                            <!--<van-collapse v-model="activeNames">-->
                                <!--<van-collapse-item v-for="(item, index) in chapterData" :key="index" :title="item.sectionname" :name="index">-->
                                    <!--<div class="catalogList" v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">-->
                                        <!--<p class="title">{{subItem.taskname}}</p>-->
                                        <!--<p class="examination" v-if="detailsData.isjoin===1" @click="joinExamination(detailsData.bankid,subItem.innerid)">-->
                                            <!--{{subItem.status === 0 ? '考试' : (subItem.status === 1 ? '继续' : (subItem.status === 10 ? '已考' : '重考'))}}-->
                                        <!--</p>-->
                                    <!--</div>-->
                                    <!--<div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无章节任务</div>-->
                                <!--</van-collapse-item>-->
                            <!--</van-collapse>-->
                        <!--</div>-->

                        <dataList :dataList="chapterData" type="0000" :item="detailsData" :isjoin="detailsData.isjoin" refs="dataList"></dataList>
                        <!--<div v-if="chapterData.length === 0" class="no_data_box">-->
                            <!--<img :src="require('@/common/images/mobile/img-noData.png')" alt="">-->
                            <!--<p>当前题库暂无目录</p>-->
                        <!--</div>-->
                    </van-tab>
                    <van-tab title="资料" v-if="detailsData.ishavedoc">
                        <materialList ref="materialList" :item="detailsData"></materialList>
                    </van-tab>
                </van-tabs>
            </div>
            <!--底部-->
            <footer v-if="detailsData.isjoin===0">
                <van-button v-if="detailsData.feetype===2" @click="pay"  type="primary"><span>购买&nbsp;¥{{detailsData.saleprice}}</span><span v-if="detailsData.uprice !== '0.00'">¥{{detailsData.uprice}}</span></van-button>
                <!--<van-button v-if="detailsData.isjoin===1" @click="joinExamination(detailsData.bankid)" type="primary">进入考试</van-button>-->
                <van-button v-if="detailsData.feetype===1" @click="joinClick" type="primary">立即参与</van-button>
            </footer>
            <footer v-if="detailsData.isjoin === 1 && detailsData.iscanexam && detailsData.qbtype === 1">
                <van-button @click="handleNowExam" type="primary">立即考试</van-button>
            </footer>
            <!--参与成功弹窗-->
            <div class="join_course_pop">
                <van-popup v-model="joinCoursePop" @close="closePop" position="center">
                    <div class="join_course_div">
                        <div>
                            <img class="join_course_img" :src="require('@/common/images/mmy/icon_success.png')" alt="">
                            <p>您已成功参与， 快去考试吧！</p>
                            <van-button @click="closePop" type="primary">好的</van-button>
                        </div>
                        <img @click="closePop" class="close_img" :src="require('@/common/images/mobile/icon-popup-close.png')" alt="">
                    </div>
                </van-popup>
            </div>
        </div>
        <!--右侧按钮-->
        <div class="serviceqrurl_pop">
            <van-popup v-model="serviceQrUrlPop" position="center">
                <p class="nama_text">{{detailsData.hostinfo.hostname}}</p>
                <img :src="detailsData.hostinfo.serviceqrurl" alt="">
                <p class="tip_text">长按识别关注客服微信号</p>
            </van-popup>
        </div>
        <div class="shortcut_box">
            <div @click="jumpClick('MIndex')">
                <img :src="require('@/common/images/other/icom_home.png')" alt="">
                <span>首页</span>
            </div>
            <div @click="handleCommonform" v-if="detailsData.iscommonform">
                <img :src="require('@/common/images/other/icon_quesnaire.png')" alt="">
                <span>问卷</span>
            </div>
            <div @click="serviceQrUrlPop = true">
                <img :src="require('@/common/images/other/icon_service.png')" alt="">
                <span>客服</span>
            </div>
        </div>
        <getCoupon ref="getCoupon" />
    </div>

</template>

<script>
    import {uploadCourseFavorite} from 'api/api'
    import {getQuestionbankDetail,uploadBankJoinInfo} from 'api/questionbank'
    import {Toast} from 'vant'
    import {mapGetters, mapActions} from 'vuex'
    import DataList from 'views/mobile/question/components/dataList.vue'
    import MaterialList from 'views/mobile/testPaper/components/dataList.vue'
    import getCoupon from '../sort/course/components/getCoupon'
    export default {
        name: 'PaperDetails',
        data() {
            return {
                isSuccess:true, //数据是否加载完成
                active:0,
                detailsData:{
                    hostinfo:{},
                },
                examinationStatus:'', //考试状态
                chapterData: [], //题库目录
                activeNames: [0],
                joinCoursePop: false, // 参与成功弹窗
                serviceQrUrlPop: false, // 客服二维码弹窗
                timer: {
                    timer: null,
                    day: 0,
                    hour: 0,
                    minute: 0,
                    second: 0
                }
            }
        },
        created() {
            if(!this.domainInfo.isMobile){
                if (this.$route.query.courseid) {
                    this.$router.push({
                        name: 'QuestionDetails',
                        query: {
                            'qid': this.$route.query.qid,
                            'courseid': this.$route.query.courseid
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'QuestionDetails',
                        query: {'qid': this.$route.query.qid}
                    })
                }
            }
        },
        activated () {
            if (this.refresh) {
                this._getList();
                this._getTask();
                this.chapterData = [];
                this.setRefresh(false)
            } else {
              if (this.detailsData.islimitcount && this.detailsData.endtime) {
                let endtime = new Date(this.detailsData.endtime).getTime()
                if (this.timer.timer) clearInterval(this.timer.timer)
                this.timer.timer = setInterval(() => {
                  this._initTimer(endtime)
                }, 1000)
              }
            }
        },
        mounted(){
            if (!this.refresh) {
                this._getList()
            }
            if (this.$route.query.active) {
                this._getTask()
            }
        },
        methods:{
            handleCommonform() {
                this.$router.push({name: 'Questionnaire', query: {commonid: this.detailsData.commonid, kmctype: 8, kmcinnerid: this.detailsData.bankid}})
            },
            openGetCoupon() {
                this.$refs.getCoupon.open(this.detailsData)
            },
            pay() {
                if (this.user.isLogin) {
                    if (this.detailsData.bankid) {
                        this.$router.push({name: 'MConfirmOrder', query: {qid: this.detailsData.bankid, kmctype: 8}})
                    }
                } else {
                    this.$router.push({name: 'MLogin'})
                }
            },
            //课程导航tab切换
            tabChange(e,event){
                if (event==='目录') {
                    if (this.chapterData.length === 0) {
                        this._getTask()
                    }
                }
                if (event === '资料') {
                    if (this.detailsData.ishavedoc) {
                        this.$nextTick(() => {
                            this.$refs.materialList.init()
                        })
                    }
                }
            },
            //获取详情
            _getList(){
                if (this.$route.query.qid) {
                    this.setLoading(true);
                    let params = {
                        bankid: this.$route.query.qid,
                        courseid: this.$route.query.courseid ? this.$route.query.courseid : ''
                    };
                    getQuestionbankDetail({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.isSuccess=false;
                            data.data.kmctype = 8
                            data.data.kmcid = this.$route.query.qid
                            this.detailsData = data.data;
                            if (this.detailsData.islimitcount && this.detailsData.endtime) {
                                let endtime = new Date(this.detailsData.endtime).getTime()
                                if (this.timer.timer) clearInterval(this.timer.timer)
                                this.timer.timer = setInterval(() => {
                                this._initTimer(endtime)
                                }, 1000)
                            }
                            this.detailsData.hostinfo=data.data.hostinfo
                            document.title=this.detailsData.subject
                        },
                        error: data => {
                            this.isSuccess = true;
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
          _initTimer(endtime) {
            let current = new Date().getTime()
            let time = (endtime - current ) / 1000
            this.timer.day = parseInt(time / 3600 / 24)
            this.timer.hour = parseInt(time / 3600) % 24 < 10 ? '0' + parseInt(time / 3600) % 24 : parseInt(time / 3600) % 24
            this.timer.minute = parseInt(time /60) % 60 < 10 ? '0' + parseInt(time /60) % 60 : parseInt(time /60) % 60
            this.timer.second = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
          },
            //获取题库目录
            _getTask(){
                // this.setLoading(true);
                // let params = {
                //     bankid: this.$route.query.qid?this.$route.query.qid:'OLLII3p9KBWhHTuZ'
                // };
                // getQuestionbankTask({
                //     data: Object.assign({}, params),
                //     success: data => {
                //         this.setLoading(false);
                //         this.chapterData = data.data.content;
                //     },
                //     error: data => {
                //         this.setLoading(false);
                //         this.$message.error(data.msg)
                //     }
                // })
            },
            // 收藏课程
            collectionClick(val) {
                if (this.user.isLogin) {
                    if (this.$route.query.qid) {
                        this.setLoading(true);
                        let params = {
                            courseid: this.$route.query.qid,
                            optype: val === 1 ? 2 : 1,
                            kmctype:8,
                        };
                        uploadCourseFavorite({
                            data: Object.assign({}, params),
                            success: data => {
                                this.setLoading(false);
                                if(data.code === '000') {
                                    if(val === 1) {
                                        this.detailsData.isfavorite = 0;
                                        Toast('已取消收藏')
                                    } else {
                                        this.detailsData.isfavorite = 1;
                                        Toast('收藏成功')
                                    }
                                }
                            },
                            error: data => {
                                console.log('error：', data)
                                this.setLoading(false)
                            }
                        })
                    }
                } else {
                    this.$router.push({name: 'MLogin'})
                }
            },
            // 参与题库（免费有效）
            joinQuestion(){
                if (this.user.isLogin) {
                    if (this.$route.query.qid) {
                        this.setLoading(true);
                        let params = {
                            bankid: this.$route.query.qid
                        };
                        uploadBankJoinInfo({
                            data: Object.assign({}, params),
                            success: data => {
                                this.setLoading(false);
                                if(data){
                                    this.joinCoursePop = true;
                                    this.detailsData.isjoin=1
                                    this.detailsData.iscanexam=1
                                }
                            },
                            error: data => {
                                this.setLoading(false);
                                this.$message.error(data.msg)
                            }
                        })
                    }
                } else {
                    this.$router.push({name: 'MLogin'})
                }
            },
            //立即参与
            joinClick(){
                this.joinQuestion()
            },
            // 关闭参与成功弹窗
            closePop() {
                this.joinCoursePop = false;
            },
            //进入考试
            joinExamination(bankid,taskid){
                this.setRefresh(true);
                this.$router.push({name: 'PaperInfo',query: {bankid:bankid,taskid: taskid}})
            },
            // 跳转至机构页面
            toOrganPage() {
                this.$router.push({name: 'MAgencyView', query: {'hostid': this.detailsData.hostinfo.hostid}})
            },
            //回到首页
            jumpClick(val) {
                this.$router.push({name: val})
            },
            // 立即考试 单试卷
            handleNowExam() {
                this.setRefresh(true);
                this.$router.push({name: 'PaperInfo',query: {bankid: this.detailsData.bankid}})
            },
            ...mapActions([
                'setLoading',
                'setRefresh'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters(['refresh','domainInfo', 'user'])
        },

        beforeRouteLeave(to, from , next) {
            clearInterval(this.timer.timer)
            next()
        },
        components: {
            DataList,
            getCoupon,
            MaterialList
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .PaperDetails{
        .imgBanner{
            width: 100%;
            height: 4.22rem;
            background: #eee;
        }
        .banner_box{

        }
        .tab_wrap{
            padding-bottom: 1.2rem;
            .hiddenDetails {
                .van-tabs__wrap {
                    display: none;
                }
            }
            /*无数据时样式*/
            .no_data_box {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 1.3rem 0;
                background: #fff;
                &>img{
                    width: 1.68rem;
                    height: 1.62rem;
                }
                &>p {
                    margin-top: 0.3rem;
                    color: #999;
                    font-size: 0.26rem;
                    line-height: 0.4rem;
                }
            }
            .detailsBox{
                /*background: #fff;*/
                /*padding: 0.32rem;*/
                .margin_bottom20{
                    margin-bottom: 0.2rem;
                }
                .paperInfo{
                    .paper_box {
                        display: flex;
                        background: #fff;
                        justify-content: space-between;
                        padding: 0.32rem;
                        align-items: center;
                        .left{
                            width: 5.9rem;
                            p{
                                font-size: 0.24rem;
                                color: #666;
                            }
                            p:first-child{
                                line-height: 0.45rem;
                                font-size: 0.32rem;
                                margin-bottom: 0.1rem;
                                font-weight: bold;
                            }
                        }
                        .right{
                            height: 0.48rem;
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            padding-left: 0.31rem;
                            margin-left: 0.2rem;
                            border-left: 0.01rem solid #E5E5E5;
                            img{
                                width: 0.44rem;
                                min-width: 0.44rem;
                                height: 0.44rem;
                                min-height: 0.44rem;
                                margin-bottom: 0.06rem;
                                margin-top: -0.15rem;
                            }
                            span{
                                font-size: 0.22rem;
                                white-space: nowrap;
                                color: #999;
                            }
                            .yellow_text {
                                color: #FFA904;
                            }
                        }
                    }
                    .coupon_box {
                      padding: 0rem 0.32rem 0.26rem;
                    background: #fff;
                      .coupon {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-top: 0.34rem;
                        border-top: 0.01rem solid #E5E5E5;
                          .left {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .name {
                              font-size: 0.28rem;
                              color: #999999;
                              margin-right: 0.5rem;
                            }
                            .get_coupon {
                              font-size: 0.24rem;
                              color: #FE666D;
                              background: #FEE4E5;
                              padding: 4px 20px;
                              box-sizing: border-box;
                              margin-right: 20px;
                            }
                            .item {
                              font-size: 0.24rem;
                              color: #FE666D;
                              border: 0.01rem solid #FE666D;
                              margin-right: 20px;
                              padding: 4px 20px;
                              border-radius: 0.04rem;
                            }
                          }
                          .right {
                            img {
                              width: 0.15rem;
                              height: 0.25rem;
                            }
                          }
                      }
                    }
                }
                .hostInfo{
                    padding: 0.32rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: #fff;
                    .hostImg{
                        display: flex;
                        align-items: center;
                        font-size: 0.32rem;
                        color: #333;
                        img{
                            width: 1.12rem;
                            height: 1.12rem;
                            margin-right: 0.2rem;
                            background: #eee;
                        }
                    }
                    img{
                        width: 0.15rem;
                        height: 0.26rem;
                    }
                }
                .bank_details_div {
                    background: #fff;
                    padding: 0.32rem;
                    line-height: 1.5;
                    overflow: hidden;
                    * {
                        max-width: 100%;
                    }
                }
            }
            .catalogBox{
                .catalogList:last-child{
                    margin-bottom: 0;
                }
                .catalogList{
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0.3rem;
                    .title{
                        width: 4.5rem;
                    }
                    .examination{
                        width:1rem;
                        height:0.46rem;
                        line-height: 0.46rem;
                        text-align: center;
                        color: #409EFF;
                        border-radius:0.22rem;
                        border:0.02rem solid rgba(64,158,255,1);
                    }
                }
                .no_task_box {
                    height: 40px;
                    line-height: 40px;
                    color: #999;
                    padding: 0 20px;
                }
            }
        }
        footer{
            position: fixed;
            bottom: 0;
            height: 1rem;
            background-color: #ffffff;
            width: 100vw;
            display: flex;
            align-items: center;
            border-top: 0.01333rem solid #f0eeee;
            box-sizing: border-box;
            .van-button{
                background: linear-gradient(180deg, #40c7ff 0%, #409eff 100%);
                width: 100%;
                height: 0.76rem;
                line-height: 0.76rem;
                border-radius: 0.38rem;
                font-size: 0.3rem;
                border: none;
                display: flex;
                justify-content: center;
                margin: 0 0.32rem;
                .van-button__text{
                    line-height: 0.76rem;
                     &>span:nth-of-type(1){
                         font-size: 0.3rem;
                     }
                    &>span:nth-of-type(2){
                        margin-left: 0.12rem;
                        font-size: 0.26rem;
                        text-decoration: line-through;
                    }
                }
            }
        }
        /*参与成功弹窗*/
        .join_course_pop {
            .van-popup--center {
                background-color: transparent;
                .join_course_div {
                    &>div {
                        padding: 0.54rem 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 4.6rem;
                        background-color: rgb(255, 255, 255);
                        border-radius:0.15rem;
                        .join_course_img {
                            width: 2.24rem;
                            height: 1.6rem;
                        }
                        &>p {
                            width: 2.8rem;
                            margin: 0.4rem 0;
                            text-align: center;
                            font-size: 0.28rem;
                            color: #333;
                            line-height: 0.4rem;
                        }
                        .van-button {
                            background:linear-gradient(180deg,rgba(64,199,255,1) 0%,rgba(64,158,255,1) 100%);
                            width: 3.48rem;
                            height: 0.6rem;
                            border-radius: 0.3rem;
                            font-size: 0.28rem;
                            border: none;
                            display: flex;
                            justify-content: center;
                            .van-button__text{
                                line-height: 0.6rem;
                            }
                        }
                    }
                    .close_img {
                        width: 0.6rem;
                        height: 0.6rem;
                        margin: 0 auto;
                        margin-top: 0.45rem;
                    }
                }
            }
        }
        .limit-box{
            padding: 0.18rem 0.32rem;
            display: flex;
            justify-content: space-between;
            height: 1.2rem;
            background: linear-gradient(24deg, #FF4952 0%, #FF8047 100%);
            color: #fff;
            box-sizing: border-box;
            .left{
                .tagname{
                    display: inline-block;
                    background: #ED4642;
                    border-radius: 0.2rem;
                    padding: 0 0.1rem;
                    height: 0.32rem;
                    line-height: 0.32rem;
                    width: auto;
                }
                .price-box{
                    height: 0.6rem;
                    margin-top: 0.1rem;
                    .saleprice{
                        font-size: 0.42rem;
                        font-weight: 600;
                    }
                    .uprice{
                        font-size: 0.28rem;
                        margin-left: 0.2rem;
                        text-decoration:line-through
                    }
                }
            }
            .right{
                .tip{
                    height: 0.32rem;
                    font-size: 0.24rem;
                    text-align: right;
                }
                .timer-box{
                    font-size: 0.28rem;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    height: 0.6rem;
                    .time-box{
                        width: 0.36rem;
                        height: 0.36rem;
                        background: #FFFFFF;
                        border-radius: 0.04rem;
                        color: #EC5E69;
                        font-size: 0.2rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .sepa-r{
                        margin-right: 0.08rem;
                    }
                    .sepa-l{
                        margin-left: 0.08rem;
                    }
                }
            }
        }
    }
    /*右侧按钮样式*/
    .serviceqrurl_pop {
        .van-popup--center {
            width: 5.2rem;
            // height: 5.58rem;
            padding: 0.4rem 0;
            box-sizing: border-box;
            border-radius:0.15rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            &>img{
                width: 3.6rem;
                height: 3.6rem;
            }
            .nama_text {
                line-height:0.4rem;
                font-size:0.28rem;
                margin-bottom: 0.2rem;
            }
            .tip_text {
                font-size:0.26rem;
                line-height:0.4rem;
                margin-top: 0.2rem;
            }
        }
    }
    .shortcut_box {
        position: fixed;
        bottom: 1.8rem;
        right: 0.32rem;
        border-radius: 0.1rem;
        background:rgba(0,0,0,0.45);
        &>div {
            margin: 0 0.16rem;
            border-bottom: 0.01rem solid #FFF;
            width: 0.56rem;
            padding: 0.12rem 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #FFF;
            &>img {
                width: 0.4rem;
                height: 0.4rem;
                margin-bottom: 0.04rem;
            }
            &>span{
                font-size:0.18rem;
                line-height:0.25rem;
            }
        }
        &>div:nth-last-of-type(1){
            border-bottom: none;
        }
    }
    /*van选项卡样式更改*/
    .van-tabs__line{
        width: 0.5rem!important;
        background-color: rgb(64, 158, 255);
    }
    .van-tab--active .van-tab__text{
        color: rgb(64, 158, 255);
    }
</style>